var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"5915bc3c590eee3a7addacf149d4a8a9d70bed8a"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from "@sentry/nextjs";

Sentry.init({
  enabled: process.env.NODE_ENV === "production" && process.env.PREVIEW === "1",
  dsn: "https://52ad3df96bb2450db58ee8b936c623f0@o1224454.ingest.sentry.io/6509877",
  tracesSampleRate: 0.1,
  ignoreErrors: [/ResizeObserver loop/],
});
